import stats from './values/trees';
import heroes from './values/HeroStats.json';
import gear from './values/Gear.json';

export const GEAR = gear;
export const HEROES = heroes;
export const STATS = stats;

export const MAX_TREE_LEVEL = 110;
export const MAX_BRANCH_LEVEL = MAX_TREE_LEVEL - 10;
export const DEFAULT_JUICE = 1000000;
export const CELERITY = "celerity";
export const MIGHT = "might";
export const FORTITUDE = "fortitude";
export const SORCERY = "sorcery";
export const SUSTENANCE = "sustenance";
export const BRANCHES = [SUSTENANCE, CELERITY, FORTITUDE, MIGHT, SORCERY];

export const AGI = "AGI";
export const STR = "STR";
export const INT = "INT";

export const SUSTENANCE_MAP = STATS[SUSTENANCE] || {};
export const CELERITY_MAP = STATS[CELERITY] || {};
export const MIGHT_MAP = STATS[MIGHT] || {};
export const SORCERY_MAP = STATS[SORCERY] || {};
export const FORTITUDE_MAP = STATS[FORTITUDE] || {};

